<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="8" sm="10">
        <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.invoices') }}</span>
      </v-col>
    </v-row>
    <v-row>
        <v-col cols="12">
            <v-card>
              <v-form v-model="isFormSearchValid">
                <v-card-title>
                  <v-row>
                    <v-col cols="5">
                      <v-text-field
                        :label="$t('label.shipId')"
                        v-model="filters.shipmentId"
                        dense
                        outlined
                        clearable
                        :rules="[rules.number]"
                        >
                      </v-text-field>
                    </v-col>
                    <v-col cols="5">
                      <v-text-field
                        :label="$t('label.invoiceDoc')"
                        v-model="filters.invoice"
                        dense
                        outlined
                        clearable
                        >
                      </v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                          color="primary"
                          @click="getInvoices"
                          :disabled="!isFormSearchValid"
                          >
                          {{ $t('label.search') }}
                          <v-icon right>
                              mdi-magnify
                          </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>
              </v-form>
              <v-card-text>
                  <v-data-table
                      :items="invoices"
                      :loading="loading.invoices"
                      :headers="headers"
                      show-expand
                      single-expand
                      :expanded.sync="expanded"
                      :options.sync="options"
                      :server-items-length="totalOfItems"
                      :footer-props="footerProps"
                      @item-expanded="onExpanded"
                      item-key="shipmentInvoiceId"
                      >
                      <template v-slot:[`item.invoiceStatus`]="{ item }">
                        <v-chip label :color="getInvoiceStatusColor(item.invoiceStatus)" :text-color="getInvoiceStatusTextColor1(item.invoiceStatus)">
                          {{ $t('InvoicePage.' + getInvoiceStatusName(item.invoiceStatus)) }}
                          <v-icon size="16" v-if="item.holdReason" :title="$t('InvoicePage.Reason')" right
                            @click.stop="openHoldReasonDialog(item)">
                            mdi-comment-text
                          </v-icon>
                          <v-icon size="16" v-if="item.rejectionReason" :title="$t('InvoicePage.Reason')" right
                            @click.stop="openReasonDialog(item)">
                            mdi-comment-text
                          </v-icon>
                        </v-chip>
                      </template>
                      <template v-slot:[`item.shipmentStatus`]="{ item }">
                        <v-chip label :color="getShipmentStatusColor(item.shipmentStatus)" :text-color="getShipmentStatusTextColor(item.shipmentStatus)">
                          {{ getShipmentStatusName(item.shipmentStatus) }}
                        </v-chip>
                      </template>
                      <template v-slot:[`item.options`]="{ item }">
                        <v-btn class="btn-action" icon small depressed :title="$t('label.reuploadInvoice')" @click.stop="openReuploadInvoiceDialog(item)">
                          <v-icon color="primary">mdi-cloud-upload</v-icon>
                        </v-btn>
                        <v-btn v-if="item.invoiceStatus === 1 || item.invoiceStatus === 20" icon small depressed :title="$t('label.deleteInvoice')" @click.stop="openDeleteInvoiceDialog(item)">
                          <v-icon color="error">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                          <v-data-table
                            :headers="headersExpand"
                            :loading="loading.billedShipments"
                            :items="item.billedShipments"
                            hide-default-footer
                            disable-pagination
                            >
                            <template v-slot:[`item.confirmationStatus`]="{ item }">
                              <v-chip label :color="getConfirmationStatusColor(item.confirmationStatus)">
                                {{ getConfirmationStatusName(item.confirmationStatus) }}
                              </v-chip>
                            </template>
                            <template v-slot:[`item.options`]="{ item }">
                              <v-btn class="btn-action" icon :title="$t('label.details')" small depressed @click.stop="openDetailDialog(item)">
                                <v-icon color="primary">mdi-file-document</v-icon>
                              </v-btn>
                            </template>
                          </v-data-table>
                        </td>
                      </template>
                      <template v-slot:top>
                          <v-toolbar flat>
                              <v-spacer>
                              </v-spacer>
                              <v-btn
                                  color="primary"
                                  @click="openUploadDialog"
                                  >
                                  {{ $t('label.uploadInvoice') }}
                                  <v-icon right>
                                      mdi-cloud-upload
                                  </v-icon>
                              </v-btn>
                          </v-toolbar>
                      </template>
                  </v-data-table>
              </v-card-text>
            </v-card>
        </v-col>
    </v-row>
    <v-dialog v-model="isUploadInvoiceOpen" persistent scrollable width="800">
        <v-form v-model="isFormValid" ref="form">
          <v-card>
              <v-card-title>
                  <v-row>
                    <v-col cols="12">
                      {{ $t('label.uploadInvoice') }}
                    </v-col>
                    <v-col v-if="userInfo.isForeignVendor" cols="12" style="color:red;">
                      {{ $t('label.uploadInvoiceNote1') }}
                    </v-col>
                    <v-col v-if="!userInfo.isForeignVendor" cols="12" style="color:red;">
                      {{ $t('label.uploadInvoiceNote') }}
                    </v-col>
                    <v-col cols="12">
                      <v-file-input
                        v-if="userInfo.isForeignVendor"
                        v-model="files"
                        accept="application/pdf,application/xml"
                        chips
                        truncate-length="45"
                        :disabled="isLoading"
                        :label="$t('label.selectInvoiceShipment')"
                        :rules="[rules.atLeastOne]"
                        :hint="$t('label.required')"
                        :loading="loading.analyzeDocument"
                        persistent-hint
                        @change="onFileChanged"
                        >
                      </v-file-input>
                      <v-file-input
                        v-if="!userInfo.isForeignVendor"
                        v-model="files"
                        accept="application/pdf,application/xml"
                        chips
                        multiple
                        truncate-length="45"
                        :disabled="isLoading"
                        :label="$t('label.selectInvoiceShipment')"
                        :rules="[rules.atLeastOne]"
                        :hint="$t('label.required')"
                        :loading="loading.analyzeDocument"
                        persistent-hint
                        >
                      </v-file-input>
                      <!-- <span class="text-caption ml-8">{{ $t('label.required') }}</span> -->
                    </v-col>
                    <v-col cols="6" v-if="userInfo.isForeignVendor">
                      <v-text-field
                        v-model="invoiceCode"
                        prepend-icon="mdi-file-document"
                        :hint="$t('label.required')"
                        persistent-hint
                        :label="$t('label.invoiceDocumentReq')"
                        :rules="userInfo.isForeignVendor === true ? [rules.required] : []"
                        >
                      </v-text-field>
                      <!-- <span v-if="userInfo.isForeignVendor" class="text-caption ml-8">{{ $t('label.required') }}</span> -->
                    </v-col>
                    <v-col cols="6" v-if="userInfo.isForeignVendor">
                      <v-text-field
                        v-model="invoiceAmount"
                        prepend-icon="mdi-cash"
                        :disabled="isLoading"
                        :label="$t('label.invoiceAmount')"
                        :rules="userInfo.isForeignVendor === true ? [rules.required, rules.number] : []"
                        :hint="$t('label.required')"
                        persistent-hint
                        >
                      </v-text-field>
                      <!-- <span v-if="userInfo.isForeignVendor" class="text-caption ml-8">{{ $t('label.required') }}</span> -->
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="search"
                        prepend-icon="mdi-magnify"
                        :disabled="isLoading"
                        hide-details
                        :label="$t('label.searchShipOrInvoice')"
                        >
                      </v-text-field>
                    </v-col>
                  </v-row>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  v-model="selectedShipments"
                  :items="shipments"
                  :loading="loading.shipments"
                  :headers="unbilledShipmentHeaders"
                  show-select
                  disable-pagination
                  hide-default-footer
                  :search="search"
                  >
                  <!-- <template v-slot:top>
                    <v-toolbar flat>
                      <v-row>

                      </v-row>
                    </v-toolbar>
                  </template> -->
                  <template v-slot:[`item.incidentCode`]="{ item }">
                    <!-- <a :href="downloadIncidentUrl + item.incidentId">{{ item.incidentCode }}</a> -->
                    <a :href="downloadIncidentUrl + item.incidentId" style="text-decoration: none">
                      <v-chip v-if="item.incidentStatus" :color="getIncidentStatusColor(item.incidentStatus)" label>
                        <!-- {{ item.incidentCode }} -->
                        {{ getIncidentStatusName(item.incidentStatus) }}
                        <v-icon right style="cursor: pointer">
                          mdi-cloud-download
                        </v-icon>
                      </v-chip>
                    </a>
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-actions>
                <v-spacer>
                </v-spacer>
                <v-btn small depressed @click.stop="isUploadInvoiceOpen = false" :disabled="isLoading">
                  {{ $t('label.close') }}
                </v-btn>
                <v-btn small depressed color="primary" @click.stop="uploadInvoice" :disabled="!isFormValid || selectedShipments.length === 0 || loading.invoiceFiles || loading.analyzeDocument">
                  {{ $t('label.save') }}
                </v-btn>
              </v-card-actions>
          </v-card>
        </v-form>
    </v-dialog>
    <!-- Reupload Files Dialog -->
    <v-dialog v-model="isReuploadInvoiceOpen" persistent scrollable width="800">
      <v-card>
        <v-card-title>
          {{ $t('label.currentInvoice') }}
          <v-spacer>
          </v-spacer>
          <v-btn
            v-if="canReuploadInvoice(selectedGroup.invoiceStatus)"
            color="primary"
            @click.stop="openInputFile()"
            :loading="loading.invoices"
            >
            {{ $t('label.reuploadInvoice') }}
            <v-icon right>
              mdi-cloud-upload
            </v-icon>
          </v-btn>
          <form ref="inputFileForm">
            <input
              type="file"
              ref="inputFile"
              multiple
              accept="application/pdf,application/xml"
              style="display:none"
              @change="previewFiles">
          </form>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :loading="loading.invoiceFiles"
            :items="currentInvoices"
            :headers="invoiceHeaders"
            hide-default-footer
            >
            <!-- <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>{{ $t('label.currentInvoice') }}</v-toolbar-title>
                <v-spacer>
                </v-spacer>
              </v-toolbar>
            </template> -->
            <template v-slot:[`item.name`]="{ item }">
              <v-row>
                <v-icon
                  v-if="item.fileExtension === 1"
                  class="mr-2"
                  color="red">
                  mdi-file-pdf-box
                </v-icon>
                <v-icon
                  v-if="item.fileExtension === 2"
                  class="mr-2"
                  color="blue"
                  >
                  mdi-xml
                </v-icon>
                <span>{{ item.name }}</span>
              </v-row>
            </template>
            <template v-slot:[`item.options`]="{ item }">
              <a :href="downloadUrl + item.id" style="text-decoration:none">
                <v-btn class="btn-action" icon :title="$t('label.download')" small depressed>
                  <v-icon color="primary">mdi-cloud-download</v-icon>
                </v-btn>
              </a>
            </template>
          </v-data-table>
          <br>
          <v-expansion-panels v-model="isHistoricExpanded">
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t('label.historicInvoices') }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-data-table
                  :loading="loading.invoiceFiles"
                  :items="history"
                  :headers="invoiceHistoryHeaders"
                  >
                  <!-- <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>{{ $t('label.historicInvoices') }}</v-toolbar-title>
                      <v-spacer>
                      </v-spacer>
                    </v-toolbar>
                  </template> -->
                  <template v-slot:[`item.name`]="{ item }">
                    <v-row>
                      <v-icon
                        v-if="item.fileExtension === 1"
                        class="mr-2"
                        color="red">
                        mdi-file-pdf-box
                      </v-icon>
                      <v-icon
                        v-if="item.fileExtension === 2"
                        class="mr-2"
                        color="blue"
                        >
                        mdi-xml
                      </v-icon>
                      <span>{{ item.name }}</span>
                    </v-row>
                  </template>
                  <template v-slot:[`item.options`]="{ item }">
                    <a :href="downloadUrl + item.id" style="text-decoration:none">
                      <v-btn class="btn-action" icon :title="$t('label.download')" small depressed>
                        <v-icon color="primary">mdi-cloud-download</v-icon>
                      </v-btn>
                    </a>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-card-actions>
          <v-spacer>
          </v-spacer>
          <v-btn small depressed @click.stop="isReuploadInvoiceOpen = false">
            {{ $t('label.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isReplaceFilesConfirmationDialogOpen" persistent width="500">
      <confirmation-dialog @confirm="confirmReplace">{{ $t('message.confirmation.filesAlreadyExist', [fileNamesFound.join(', ')]) }}</confirmation-dialog>
    </v-dialog>
    <v-dialog v-model="isDetailDialogOpen" persistent width="1200">
      <shipment-detail :shipmentId="selectedShipmentId" @close="isDetailDialogOpen = false" :print="true"></shipment-detail>
    </v-dialog>
    <v-dialog v-model="isDeleteInvoiceDialogOpen" persistent width="500">
      <confirmation-dialog @confirm="confirmDelete">{{ $t('message.confirmation.deleteInvoice') }}</confirmation-dialog>
    </v-dialog>
    <v-dialog v-model="isReasonDialogOpen" persistent width="800">
      <v-card>
        <v-card-title>
          {{ $t('label.rejectReason') }}
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="selectedReason"
            outlined
            hide-details
            :label="$t('label.reason')"
            readonly
            >
          </v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer>
          </v-spacer>
          <v-btn small depressed @click.stop="isReasonDialogOpen = false">
            {{ $t('label.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isHoldInvoiceDialogOpen" persistent width="800">
      <v-card>
        <v-card-title>
          {{ $t('InvoicePage.HoldInvoice') }}
        </v-card-title>
        <v-form>
          <v-card-text>
            <v-textarea v-model="selectedHoldReason" outlined :label="$t('InvoicePage.Reason')" readonly>
            </v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer>
            </v-spacer>
            <v-btn small depressed @click.stop="isHoldInvoiceDialogOpen = false">
              {{ $t('InvoicePage.Close') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { showMessage, rules, loading, userInfo } from '../../mixins'
import ConfirmationDialog from '../../components/Shared/ConfirmationDialog.vue'
import ShipmentDetail from '../../components/EDI/shipments/ShipmentDetail.vue'
export default {
  mixins: [showMessage, rules, loading, userInfo],
  components: { ConfirmationDialog, ShipmentDetail },
  data: () => ({
    totalOfItems: 0,
    options: {},
    page: 1,
    itemsPerPage: 10,
    footerProps: {
      'items-per-page-options': [5, 10, 15, 30, 100]
    },
    downloadUrl: `${process.env.VUE_APP_API_URL}/api/shipments/download-invoice/`,
    downloadIncidentUrl: `${process.env.VUE_APP_API_URL}/api/shipments/incident/`,
    search: '',
    invoices: [],
    shipments: [],
    invoiceAmount: '',
    selectedShipments: [],
    selectedShipmentId: null,
    selectedHoldReason: null,
    isHoldInvoiceDialogOpen: false,
    currentInvoices: [],
    history: [],
    files: [],
    loading: {
      invoices: false,
      shipments: false,
      billedShipments: false,
      invoiceFiles: false,
      analyzeDocument: false
    },
    invoiceCode: '',
    filters: {
      shipmentId: '',
      invoice: ''
    },
    isUploadInvoiceOpen: false,
    isReuploadInvoiceOpen: false,
    isReplaceFilesConfirmationDialogOpen: false,
    isDetailDialogOpen: false,
    isReasonDialogOpen: false,
    isDeleteInvoiceDialogOpen: false,
    isFormValid: null,
    isFormSearchValid: null,
    expanded: [],
    selectedGroup: {
      invoiceStatus: 0
    },
    selectedFiles: [],
    fileNamesFound: [],
    isHistoricExpanded: false,
    selectedReason: ''
  }),
  computed: {
    headers () {
      const headers = [
        { text: this.$t('label.groupId'), value: 'shipmentInvoiceId', align: 'center', sortable: false, filterable: false },
        // { text: this.$t('label.pdfFileName'), value: 'pdfFileName', align: 'center', sortable: false, filterable: false },
        // { text: this.$t('label.xmlFileName'), value: 'xmlFileName', align: 'center', sortable: false, filterable: false },
        { text: this.$t('label.uploadDate'), value: 'formattedUploadDate', align: 'center', sortable: false, filterable: false },
        { text: this.$t('label.invoiceStatus'), value: 'invoiceStatus', align: 'center', sortable: false, filterable: false },
        { text: this.$t('label.shipmentStatus'), value: 'shipmentStatus', align: 'center', sortable: false, filterable: false },
        { text: this.$t('label.options'), value: 'options', align: 'center', sortable: false, filterable: false }
      ]
      return headers
    },
    headersExpand () {
      const headers = [
        { text: this.$t('label.shipId'), value: 'shipmentId', align: 'center', sortable: false, filterable: false },
        { text: this.$t('label.creationDate'), value: 'creationDateFormatted', align: 'center', sortable: false, filterable: false },
        { text: this.$t('label.confirmationStatus'), value: 'confirmationStatus', align: 'center', sortable: false, filterable: false },
        { text: this.$t('label.invoiceDocument'), value: 'invoice', align: 'center', sortable: false, filterable: false },
        { text: this.$t('label.options'), value: 'options', align: 'center', sortable: false, filterable: false }
      ]
      return headers
    },
    // shipments () {
    //   const shipments = [...this.searchShipments, ...this.selectedShipments]
    //   return shipments
    // },
    invoiceHeaders () {
      return [
        { text: this.$t('label.fileName'), value: 'name', align: 'center', sortable: false, filterable: true },
        { text: this.$t('label.uploadDate'), value: 'uploadDateFormated', align: 'center', sortable: false, filterable: true },
        { text: this.$t('label.options'), value: 'options', align: 'center', sortable: false, filterable: true }
      ]
    },
    invoiceHistoryHeaders () {
      return [
        { text: this.$t('label.fileName'), value: 'name', align: 'center', sortable: false, filterable: true },
        { text: this.$t('label.uploadDate'), value: 'uploadDateFormated', align: 'center', sortable: false, filterable: true },
        { text: this.$t('label.options'), value: 'options', align: 'center', sortable: false, filterable: false }
      ]
    },
    unbilledShipmentHeaders () {
      const headers = [
        { text: '', value: 'data-table-select', class: 'sticky-header white' },
        { text: this.$t('label.shipId'), value: 'id', align: 'center', sortable: false, filterable: true, class: 'sticky-header white' },
        { text: this.$t('label.creationDate'), value: 'creationDateFormatted', align: 'center', sortable: false, filterable: true, class: 'sticky-header white' },
        { text: this.$t('label.invoiceDocument'), value: 'invoice', align: 'center', sortable: false, filterable: true, class: 'sticky-header white' },
        { text: this.$t('label.incidentStatus'), value: 'incidentCode', align: 'center', sortable: false, filterable: true, class: 'sticky-header white' }
      ]
      return headers
    }
  },
  methods: {
    onFileChanged () {
      if (this.files.length < 1 || !this.userInfo.isForeignVendor) {
        return
      }
      this.analyzeDocument(this.files)
    },
    async analyzeDocument (file) {
      try {
        this.loading.analyzeDocument = true
        const formData = new FormData()
        formData.append('file', file)
        const response = await this.$proxy.post('api/invoices/analyze', formData)
        this.invoiceCode = response.data.invoiceId
        this.invoiceAmount = response.data.invoiceTotal
      } catch (error) {
        this.showHttpErrorMessage(error)
      } finally {
        this.loading.analyzeDocument = false
      }
    },
    openDeleteInvoiceDialog (item) {
      this.selectedGroup = Object.assign({}, item)
      this.isDeleteInvoiceDialogOpen = true
    },
    async confirmDelete (confirm) {
      if (confirm) {
        await this.deleteInvoice()
      }
      this.isDeleteInvoiceDialogOpen = false
    },
    async deleteInvoice () {
      try {
        this.loading.invoices = true
        await this.$proxy.delete(`api/shipment-invoices/${this.selectedGroup.shipmentInvoiceId}`)
        await this.getInvoices()
      } catch (error) {
        this.showHttpErrorMessage(error)
      } finally {
        this.loading.invoices = false
      }
    },
    openHoldReasonDialog (item) {
      this.ShowHoldButton = false
      this.selectedHoldReason = item.holdReason
      this.isHoldInvoiceDialogOpen = true
    },
    openReasonDialog (item) {
      this.selectedReason = item.rejectionReason
      this.isReasonDialogOpen = true
    },
    openDetailDialog (item) {
      this.selectedShipmentId = item.shipmentId
      this.isDetailDialogOpen = true
    },
    async getInvoices () {
      try {
        const params = new URLSearchParams()
        if (this.filters.shipmentId) {
          params.append('shipmentId', this.filters.shipmentId)
        }
        if (this.filters.invoice) {
          params.append('invoice', this.filters.invoice)
        }
        this.loading.invoices = true
        const response = await this.$proxy.get(`api/invoices/${this.page}/${this.itemsPerPage}?${params.toString()}`)
        const invoices = response.data.items
        this.totalOfItems = response.data.totalOfItems
        invoices.forEach(i => {
          i.billedShipments = []
        })
        this.invoices = invoices
      } catch (error) {
        this.showHttpErrorMessage(error)
      } finally {
        this.loading.invoices = false
      }
    },
    async uploadInvoice () {
      try {
        console.log('uploadInvoice')
        this.changeLoadingStatus(true)
        this.loading.invoiceFiles = true
        this.loading.shipments = true
        const formData = new FormData()
        if (this.userInfo.isForeignVendor) {
          formData.append('files', this.files)
          formData.append('isForeignVendor', true)
        } else {
          this.files.forEach(file => formData.append('files', file))
          formData.append('isForeignVendor', false)
        }
        this.selectedShipments.forEach(s => formData.append('shipmentIds', s.id))
        if (this.invoiceCode) {
          formData.append('invoiceCode', this.invoiceCode)
        }
        if (this.invoiceAmount) {
          formData.append('invoiceAmount', this.invoiceAmount)
        }
        await this.$proxy.post('api/shipments/invoice', formData)
        await this.getInvoices()
        this.showMessage(this.$t('message.success.savedCorrectly'))
        this.isUploadInvoiceOpen = false
      } catch (error) {
        this.showHttpErrorLongTimeMessage(error)
      } finally {
        this.loading.invoiceFiles = false
        this.loading.shipments = false
        this.changeLoadingStatus(false)
      }
    },
    async openUploadDialog () {
      this.files = []
      this.selectedShipments = []
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
      await this.getUnbilledShipments()
      this.isUploadInvoiceOpen = true
    },
    onExpanded (e) {
      const { item, value } = e
      if (value && item.billedShipments.length === 0) {
        this.getBilledShipments(item)
      }
    },
    async getBilledShipments (item) {
      try {
        this.loading.billedShipments = true
        const response = await this.$proxy.get(`api/invoices/billed-shipments/${item.shipmentInvoiceId}`)
        item.billedShipments = response.data
      } catch (error) {
        this.showHttpErrorMessage(error)
      } finally {
        this.loading.billedShipments = false
      }
    },
    openReuploadInvoiceDialog (item) {
      this.isReuploadInvoiceOpen = true
      this.selectedGroup = item
      this.getInvoicesFiles()
    },
    async getInvoicesFiles () {
      try {
        this.loading.invoiceFiles = true
        const response = await this.$proxy.get(`api/shipments/${this.selectedGroup.shipmentInvoiceId}/invoice`)
        this.currentInvoices = response.data.current
        this.history = response.data.history
      } catch (error) {
        this.showHttpErrorMessage(error)
      } finally {
        this.loading.invoiceFiles = false
      }
    },
    async previewFiles () {
      const files = this.$refs.inputFile.files
      if (files.length === 0) {
        return
      }

      try {
        this.loading.invoiceFiles = true
        const fileNames = []
        this.selectedFiles = []
        const formData = new FormData()
        files.forEach(file => {
          fileNames.push(file.name)
          this.selectedFiles.push(file)
          formData.append('files', file)
        })
        const response = await this.$proxy.post(`api/shipments/verify-files/${this.selectedGroup.shipmentInvoiceId}`, fileNames)
        this.fileNamesFound = response.data
        if (this.fileNamesFound.length === 0) {
          await this.$proxy.post(`api/shipments/${this.selectedGroup.shipmentInvoiceId}/invoice-replace`, formData)
          this.showMessage(this.$t('message.success.uploadCorrectly'))
          this.getInvoices()
          this.getInvoicesFiles()
        } else {
          this.isReplaceFilesConfirmationDialogOpen = true
        }
      } catch (e) {
        this.showHttpErrorMessage(e)
      } finally {
        this.loading.invoiceFiles = false
        this.$refs.inputFileForm.reset()
      }
    },
    async confirmReplace (confirm) {
      if (confirm) {
        await this.uploadAndReplace()
      } else {
        this.$refs.inputFileForm.reset()
      }
      this.isReplaceFilesConfirmationDialogOpen = false
    },
    async uploadAndReplace () {
      const formData = new FormData()
      this.selectedFiles.forEach(file => formData.append('files', file))
      try {
        this.loading.invoiceFiles = true
        await this.$proxy.post(`api/shipments/${this.selectedGroup.shipmentInvoiceId}/invoice-replace`, formData)
        await this.getInvoicesFiles()
        await this.getInvoices()
        this.showMessage(this.$t('message.success.uploadCorrectly'))
      } catch (e) {
        this.showHttpErrorLongTimeMessage(e)
      } finally {
        this.loading.invoiceFiles = false
        this.$refs.inputFileForm.reset()
      }
    },
    openInputFile () {
      this.$refs.inputFile.click()
    },
    async getUnbilledShipments () {
      try {
        this.loading.shipments = true
        const response = await this.$proxy.get('api/shipments/unbilled')
        this.shipments = response.data
      } catch (error) {
        this.showHttpErrorMessage(error)
      } finally {
        this.loading.shipments = false
      }
    },
    getShipmentStatusName (statusId) {
      switch (statusId) {
        case 1:
          return this.$t('label.pendingToReceive')
        case 2:
          return this.$t('label.partialReception')
        case 3:
          return this.$t('label.receptionComplete')
      }
    },
    getInvoiceStatusName (statusId) {
      switch (statusId) {
        case 1:
          return 'ValidationPending'
        case 2:
          return 'PendingToPay'
        case 3:
          return 'PartialPayment'
        case 4:
          return 'PaymentComplete'
        case 10:
          return 'OnHold'
        case 20:
          return 'Rejected'
      }
    },
    getShipmentStatusColor (statusId) {
      switch (statusId) {
        case 1:
          return 'gray'
        case 2:
          return 'yellow'
        case 3:
          return 'green'
      }
    },
    getInvoiceStatusColor (statusId) {
      switch (statusId) {
        case 1:
          return 'gray'
        case 2:
          return 'yellow'
        case 3:
          return 'green'
        case 10:
          return 'gray'
        case 20:
          return '#FF5252'
      }
    },
    getInvoiceStatusTextColor1 (statusId) {
      switch (statusId) {
        case 1:
          return '#222'
        case 2:
          return '#000'
        case 3:
          return '#222'
        case 4:
          return '#000'
        case 10:
          return '#222'
        case 20:
          return '#FFF'
      }
    },
    getIncidentStatusName (statusId) {
      switch (statusId) {
        case 1:
          return 'Open'
        case 2:
          return 'Resolved'
        case 3:
          return 'Cancelled'
      }
    },
    getIncidentStatusColor (statusId) {
      switch (statusId) {
        case 1:
          return 'error'
        case 2:
          return 'gray'
        case 3:
          return 'gray'
      }
    },
    canReuploadInvoice (statusId) {
      if (statusId === 1 || statusId === 20 || statusId === 0) {
        return true
      }
      return false
    },
    getConfirmationStatusName (statusId) {
      switch (statusId) {
        case 0:
          return this.$t('label.pendingToReceive')
        case 1:
          return this.$t('label.received')
      }
    },
    getConfirmationStatusColor (statusId) {
      switch (statusId) {
        case 0:
          return 'warning'
        case 1:
          return 'success'
      }
    },
    getShipmentStatusTextColor (statusId) {
      switch (statusId) {
        case 1:
          return 'black'
        case 2:
          return 'black'
        case 3:
          return '#FFF'
      }
    }
  },
  // watch: {
  //   search (val) {
  //     if (this.loading.shipments) return

  //     if (!val) {
  //       this.searchShipments = []
  //       return
  //     }

  //     this.loading.shipments = true
  //     this.$proxy.get(`api/shipments/unbilled/${val}`)
  //       .then(res => {
  //         this.searchShipments = res.data
  //       })
  //       .catch(error => {
  //         this.showHttpErrorMessage(error)
  //       })
  //       .finally(_ => {
  //         this.loading.shipments = false
  //       })
  //   }
  // },
  mounted () {
    this.getInvoices()
  },
  created () {

  },
  watch: {
    options: {
      handler () {
        const { page, itemsPerPage } = this.options
        this.page = page
        this.itemsPerPage = itemsPerPage
        this.getInvoices()
      },
      deep: true
    },
    isUploadInvoiceOpen: {
      handler (val) {
        if (val) {

        }
      }
    }
  }
}
</script>

<style scoped>
  .v-data-table /deep/ .sticky-header {
    position: sticky;
    top: 0px;
    z-index: 2;
  }

  .v-data-table /deep/ .v-data-table__wrapper {
    overflow: unset;
  }
</style>
